<template>
  <component :class="['typography', variant]" :is="as" @click="handleClick">
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: "Typography",
  props: {
    as: {
      type: String,
      default: "div",
      validator: (value) =>
        ["div", "h1", "h2", "h3", "h4", "h5", "h6", "span", "p", "a"].includes(value),
    },
    variant: {
      type: String,
      default: "body-2",
      validator: (value) =>
        // can add more variants later if needed.
        [
          "body-1",
          "body-2",
          "subtitle-1",
          "subtitle-2",
          "h-1",
          "h-2",
          "h-3",
          "h-4",
          "h-5",
          "h-6",
          "caption-1",
          "caption-2",
          "bold",
        ].includes(value),
    },
  },
  emits: ["click"],
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style scoped>
.typography {
  font-family: "Avenir", Helvetica, Arial, sans-serif !important;
}
.body-1 {
  font-family: "Avenir Book", Helvetica, Arial, sans-serif !important;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0 !important;
}
.body-2 {
  font-family: "Avenir Book", Helvetica, Arial, sans-serif !important;
  font-size: 14px;
  line-height: 22px;
}
.subtitle-1 {
  font-family: "Avenir Heavy", Helvetica, Arial, sans-serif !important;
  font-size: 16px;
  line-height: 24px;
}
.subtitle-2 {
  font-family: "Avenir Heavy", Helvetica, Arial, sans-serif !important;
  font-size: 14px;
  line-height: 22px;
}
.h-1 {
  font-family: "Avenir Heavy", Helvetica, Arial, sans-serif !important;
  font-size: 32px;
  line-height: 40px;
}
.h-2 {
  font-family: "Avenir Heavy", Helvetica, Arial, sans-serif !important;
  font-size: 26px;
  line-height: 32px;
}
.h-3 {
  font-family: "Avenir Medium", Helvetica, Arial, sans-serif !important;
  font-size: 24px;
  line-height: 32px;
}
.h-4 {
  font-family: "Avenir Medium", Helvetica, Arial, sans-serif !important;
  font-size: 22px;
  line-height: 32px;
}
.h-5 {
  font-family: "Avenir Medium", Helvetica, Arial, sans-serif !important;
  font-size: 20px;
  line-height: 28px;
}
.h-6 {
  font-size: 18.72px;
  font-weight: 400;
}
.caption-1 {
  font-family: "Avenir Light", Helvetica, Arial, sans-serif !important;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.2px;
}
.caption-2 {
  font-family: "Avenir Light", Helvetica, Arial, sans-serif !important;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.2px;
}
.body-2-bold {
  font-family: "Avenir Book", Helvetica, Arial, sans-serif !important;
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
}
</style>
